module.exports = __webpack_public_path__ + "img/logo.8358f700.png";